import axios from 'axios';
import config from 'shared/config';
import qs from 'qs';
import setBaseRequest from 'shared/utils/setBaseRequest';
import {
	asyncCancel,
	asyncStart,
	asyncSuccess,
	asyncError,
} from 'redux/domain/AsyncStatus/actions';
import { batchActions } from 'redux-batched-actions';
import { createNotification } from 'redux/domain/Notifications/creators';
import { makeFindCustomerKeyPath, makeZipVerificationKeyPath } from './keyPath';

export const cancelVerifyZipCode = (asyncId, zipCodeFieldPath = null) => dispatch => {
	const keyPath = makeZipVerificationKeyPath(asyncId, zipCodeFieldPath);
	dispatch(asyncCancel(keyPath));
};

export const findCustomer = (asyncId, formValues) => async dispatch => {
	const asyncKeyPath = makeFindCustomerKeyPath(asyncId);
	const cancellationSource = axios.CancelToken.source();
	// begin fetch by setting async status and storing the cancellation source
	dispatch(asyncStart(asyncKeyPath, cancellationSource));
	let response;

	// fetch
	try {
		response = await axios.post(
			`${config.ESTORIS_BASE_PATH}/FindCustomerFRCredit`,
			qs.stringify(formValues),
			setBaseRequest({}, cancellationSource.token),
		);
		// update sync status
		dispatch(asyncSuccess(asyncKeyPath));
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error and present a notification
			dispatch(
				batchActions([
					asyncError(asyncKeyPath, error),
					createNotification('Trouble locating customer information'),
				]),
			);
		}
	}
	return response;
};

export const verifyZipCode = (
	asyncId,
	zipCode,
	state = null,
	zipCodeFieldPath = null,
) => async dispatch => {
	const asyncKeyPath = makeZipVerificationKeyPath(asyncId, zipCodeFieldPath);
	const cancellationSource = axios.CancelToken.source();
	// begin fetch by setting async status and storing the cancellation source
	dispatch(asyncStart(asyncKeyPath, cancellationSource));
	let response;

	// fetch
	try {
		response = await axios.get(
			`${config.ESTORIS_BASE_PATH}/IsValidZipCode`,
			setBaseRequest({ zipCode, state }, cancellationSource.token),
		);
		// update sync status
		dispatch(asyncSuccess(asyncKeyPath));
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error and present a notification
			dispatch(
				batchActions([
					asyncError(asyncKeyPath, error),
					createNotification('Trouble verifying Zip Code'),
				]),
			);
		}
	}
	return response;
};
